import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MonitoringModule } from '@epicuro-next/platform/monitoring';
import { EffectsModule } from '@ngrx/effects';

import { EventTrackerEffects } from './store/effects';

@NgModule({
  imports: [
    CommonModule,
    MonitoringModule,
    EffectsModule.forFeature([EventTrackerEffects]),
  ],
})
export class EventTrackerStateModule {}
